import { create } from "zustand";
import { fetchTeamMembersListByProjectIdService } from "../services/teamMembersListByProjectIDServices";

export const useTeamMembersListByProjectIDStore = create((set) => ({
  teamMembersList: [],
  loading: false,
  fetchTeamMembers: async (projectId) => {
    await fetchTeamMembersListByProjectIdService(set, projectId);
  },
  setTeamMembersList: (list) => set({ teamMembersList: list }),
}));
